// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import store from './store'

Vue.use(VueResource)

Vue.config.productionTip = false

Vue.http.interceptors.push((request, next) => {
  const jwt = localStorage.getItem('jwt')
  if (jwt) {
    request.headers.set('Authorization', jwt)
  }
  request.headers.set('Accept', 'application/json')
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  created () {
    window.addEventListener('keyup', (event) => {
      if (event.keyCode === 37) {
        // left
        if (this.$store.state.comicId > 1) {
          this.$router.push({
            path: '/' + (this.$store.state.comicId - 1)
          })
        }
      }
      if (event.keyCode === 39) {
        // right
        if (this.$store.state.comicId < this.$store.state.maxComicId) {
          this.$router.push({
            path: '/' + (this.$store.state.comicId + 1)
          })
        }
      }
    })
    this.$http.get(process.env.API_URL + '/checklogin.php').then(res => {
      if (res.body.status === 'success') {
        this.$store.dispatch('loginUser', res.body.data)
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js